import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { BrandColors } from '../../constants';
interface VideoTaskStyles {
  backgroundColor?: string;
}
export const VideoTaskContentStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: (props: VideoTaskStyles) => ({
      margin: 0,
      padding: '0.5rem 1.25rem',
      background: props?.backgroundColor,
      minHeight: '2.5rem',
    }),
    closeButton: {
      position: 'absolute',
      right: '0.5rem',
      top: '0rem',
      color: 'inherit',
      padding: '0.5rem',
      zIndex: 1,
    },
    ckScroll: {
      overflow: 'scroll',
    },
    dialogContainer: (props: VideoTaskStyles) => ({
      overflow: 'hidden',
      top: '2.5rem !important',
      [theme.breakpoints.up('sm')]: {
        margin: '3.125rem 2.125rem 0',
      },
      [theme.breakpoints.up('md')]: {
        top: '3.125rem !important',
      },
      [theme.breakpoints.up('lg')]: {
        margin: '1rem 0 0',
      },
      '& .MuiDialog-paper': {
        background: props?.backgroundColor,
        width: '100%',
        overflow: 'hidden',
        maxHeight: '100%',
        margin: '0px',
        [theme.breakpoints.up('lg')]: {
          maxWidth: '50%',
        },
      },
      '& .MuiDialog-container': {
        height: '100%',
        position: 'relative',
      },
      '& .MuiBackdrop-root': {
        zIndex: 'auto',
        backgroundColor: 'unset',
        [theme.breakpoints.up('sm')]: {
          backgroundColor: BrandColors.modalBackdropColor,
        },
      },
      '& .MuiAccordionSummary-content.Mui-expanded': {
        margin: '12px 0',
      },
    }),
  }),
);
